// extracted by mini-css-extract-plugin
export var emailBlockLink = "_iw-0";